import solver from 'solver-utilities';

const tab = function (index) {
	const tabs = document.querySelectorAll('.client-reviews--tabs .collapse');
	tabs.forEach((tab) => tab.classList.remove('collapse--active'));

	tabs[index].classList.add('collapse--active');
};

const slider = function () {
	const container = document.querySelector('.client-reviews--slider');

	if (!container) return;

	const quotes = container.querySelectorAll('blockquote');

	let index = 0;
	const rotate = async function () {
		quotes[index].style.display = 'block';
		await solver.each.asyncTimeout(250);
		quotes[index].classList.add('client-review--active');

		setTimeout(async () => {
			quotes[index].classList.remove('client-review--active');
			await solver.each.asyncTimeout(250);
			quotes[index].style.display = 'none';

			if (index >= quotes.length - 1) {
				index = 0;
			} else {
				index++;
			}

			rotate();
		}, 10000);
	};

	rotate();
};

export const clientReviews = function () {
	slider();
	window.tab = tab;
};
